import { Directive, EventEmitter, HostBinding, HostListener, inject, Input, Output } from '@angular/core';
import { NotificationsService } from '../services/notifications-service/notifications.service';
import { TranslationService } from '../transloco/services/translation.service';

@Directive({
    selector: '[appFileDrag]',
    standalone: false,
})
export class FileDragDirective {
    private notificationsService = inject(NotificationsService);

    private readonly dragableClass = 'dragable';
    private readonly dragoverClass = 'dragover';
    private translationService = inject(TranslationService);

    @Input() public allowedFileType: string;
    @Input() public allowedFileSize: number;
    @Input() public allowedFileSizeMessage: string;
    @Output() public files: EventEmitter<File[]> = new EventEmitter();

    @HostBinding('class') public class = this.dragableClass;

    @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.class = this.dragoverClass;
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.class = this.dragableClass;
    }

    @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        this.class = this.dragableClass;

        const files: File[] = [];
        for (let i = 0; i < evt.dataTransfer.files.length; i++) {
            const file = evt.dataTransfer.files[i];

            if (!file.type.match(this.allowedFileType)) {
                this.notificationsService.error(this.translationService.translate('defaults.validation.unsupportedFileFormat', { fileName: file.name }));
                continue;
            }

            if (isFileSizeExeeded(file, this.allowedFileSize)) {
                this.notificationsService.error(this.translationService.translate('defaults.validation.fileSizeTooLarge', { fileName: file.name, fileSize: this.allowedFileSizeMessage }));
                continue;
            }

            files.push(file);
        }

        if (files.length > 0) {
            this.files.emit(files);
        }
    }
}

export function isFileSizeExeeded(file: File, allowedFileSize: number) {
    return file.size > allowedFileSize;
}

export function isFileTypeNotAllowed(file: File, allowedFileType: string) {
    return !file.type.match(allowedFileType);
}
